<template>
    <button type="button" :class="spClass" class="btn">
        <icon :class="icon" :icon="icon" :height="iconHeight" :width="iconWidth"></icon>
    </button>
</template>

<script>

import Icon from '@/components/atoms/Icon'

export default {
    name: 'TableButton',
    components: {
        Icon
    },
    props: {
        spClass: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        iconHeight: {
            type: Number,
            required: false,
            default: 20
        },
        iconWidth: {
            type: Number,
            required: false,
            default: 20
        },
        text: {
            type: String,
            required: false
        },
        smallText: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">

.btn {
    background: transparent;
    border: none;
    outline: none;
    display: flex;
    cursor: pointer;
    width: 100%;
    justify-content: center;
    align-items: center;
    justify-self: flex-end;
    color: $dark;
}
.width-auto {
    width: auto
}

</style>
